<sh-form-input-with-droppanel [id]="id$ | async" [label]="label$ | async" [variant]="variant$ | async" [droppanelStyle]="droppanelStyle$ | async">
    <form [formGroup]="form">
        <div class="sh-droppanel__content">
            <ul class="sh-form-check-list">
                <li class="sh-form-check-list__item">
                    <div class="sh-form-check sh-form-check-list__item__check">
                        <!-- Both name and attr.name should be set on radio buttons, see https://github.com/angular/angular/issues/11757 -->
                        <input
                            type="radio"
                            [id]="(id$ | async) + '-date-filter-type-selection-range'"
                            [formControl]="filterTypeControl"
                            [value]="filterDateType.RANGE"
                            [name]="(id$ | async) + '-date-filter-type-selection'"
                            [attr.name]="(id$ | async) + '-date-filter-type-selection'"
                            class="sh-radio sh-form-check__input sh-form-group__input"
                        />
                        <label [for]="(id$ | async) + '-date-filter-type-selection-range'" class="sh-form-check__label">{{ filterLabels.range }}</label>
                    </div>
                    <div class="sh-form-check-list__item__content">
                        <sh-form-date-select
                            class="sh-filter-date-action-row"
                            [id]="(id$ | async) + '-date-filter-range-from'"
                            [control]="filterRangeFromControl"
                            [label]="filterLabels.from"
                            [yearLabel]="filterLabels.year"
                            [monthLabel]="filterLabels.month"
                            [dayLabel]="filterLabels.day"
                        ></sh-form-date-select>
                        <sh-form-date-select
                            class="sh-filter-date-action-row"
                            [id]="(id$ | async) + '-date-filter-range-to'"
                            [control]="filterRangeToControl"
                            [label]="filterLabels.until"
                            [yearLabel]="filterLabels.year"
                            [monthLabel]="filterLabels.month"
                            [dayLabel]="filterLabels.day"
                        ></sh-form-date-select>
                        <ng-container *ngIf="isSelectedDateType(filterDateType.RANGE)">
                            <ng-container *ngTemplateOutlet="errorMessage"></ng-container>
                        </ng-container>
                    </div>
                </li>
                <li class="sh-form-check-list__item">
                    <div class="sh-form-check sh-form-check-list__item__check">
                        <!-- Both name and attr.name should be set on radio buttons, see https://github.com/angular/angular/issues/11757 -->
                        <input
                            type="radio"
                            [id]="(id$ | async) + '-date-filter-type-selection-specific'"
                            [value]="filterDateType.SPECIFIC"
                            [formControl]="filterTypeControl"
                            [name]="(id$ | async) + '-date-filter-type-selection'"
                            [attr.name]="(id$ | async) + '-date-filter-type-selection'"
                            class="sh-radio sh-form-check__input sh-form-group__input"
                        />
                        <label [for]="(id$ | async) + '-date-filter-type-selection-specific'" class="sh-form-check__label">{{ filterLabels.specific }}</label>
                    </div>
                    <div class="sh-form-check-list__item__content">
                        <sh-form-date-select
                            class="sh-filter-date-action-row"
                            [id]="(id$ | async) + '-date-filter-range-specific'"
                            [control]="filterSpecificControl"
                            [yearLabel]="filterLabels.year"
                            [monthLabel]="filterLabels.month"
                            [dayLabel]="filterLabels.day"
                        ></sh-form-date-select>
                        <ng-container *ngIf="isSelectedDateType(filterDateType.SPECIFIC)">
                            <ng-container *ngTemplateOutlet="errorMessage"></ng-container>
                        </ng-container>
                    </div>
                </li>
            </ul>
        </div>
        <div class="sh-droppanel__footer">
            <div class="sh-action-group -sh-align-end -sh-condense">
                <button type="submit" class="sh-button sh-action-group__item" (click)="setFilterValues()" [disabled]="!(this.canSetFilterValues$ | async)">
                    {{ filterLabels.submit }}
                </button>
            </div>
        </div>
    </form>
</sh-form-input-with-droppanel>

<ng-template #errorMessage>
    <div *ngIf="error$ | async" class="sh-form-group -sh-is-invalid">
        <p class="sh-form-group__feedback">{{ error$ | async }}</p>
    </div>
</ng-template>
